module.exports = "<h4>{{vechtype}} -</h4>\n<br>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/const/getdevdetail/getdevdetail.component.html
// module id = ../../../../../src/app/const/getdevdetail/getdevdetail.component.html
// module chunks = main